import { useClient, useDictionary } from "@adamlip/okeoke.client"
import { Button, CircularProgress, Slider } from "@nextui-org/react"
import UsePointsModal from "components/Modals/UsePointsModal"
import { AppParamsContext } from "contexts/AppParamsContext"
import { UserContext } from "contexts/UserContext"
import QRCodeSVG from "qrcode.react"
import { useContext, useState } from "react"
import ReactCardFlip from "react-card-flip"
import toast from "react-hot-toast"
import Login from "views/Login"

function VIP() {
  const { languageCode, brandID } = useClient()
  const { appParams } = useContext(AppParamsContext)

  const {
    pointRedemption,
    userVipPoints,
    reserveLoading,
    setUsePoints,
    userData,
    isVipBrand,
    userLoggedIn,
  } = useContext(UserContext)
  const { getValue } = useDictionary()
  const [isFlipped, setIsFlipped] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const [sliderValue, setSliderValue] = useState(0)
  const [loginModal, setLoginModal] = useState(false)
  const handleSetPoints = () => {
    if (reserveLoading) return null
    if (typeof setUsePoints === "function") {
      setUsePoints(sliderValue).then((res) => {
        if (res.success) {
          toast.success(
            `${getValue("app_v2_vip_points_set_success")} - ${sliderValue}`
          )
        } else {
          toast.error(getValue("app_v2_vip_points_set_failed"))
        }
      })
    }
  }

  //let defaultVipCardBgImgUrl = `https://cdn.okeoke.io/brands/${brandID}/assets/vip_card_default.png`;
  let defaultVipCardBgImgUrl =
    userData?.cardImageUrl ||
    appParams?.assets?.vipBackgroundImg ||
    `https://cdn.okeoke.io/brands/${brandID}/assets/vip_card_default.png`
  if (!userLoggedIn) {
    return (
      <div className="flex flex-col gap-2 items-center justify-center h-full w-full max-w-[95%] mx-auto  relative overflow-y-scroll pb-[50%]">
        <div className="w-full text-center text-xl font-bold">
          {getValue("app_v2_youAreNotLoggedIn")}
        </div>
        <div className="w-full text-center mb-4">
          {getValue("app_v2_youAreNotLoggedIn_desc")}
        </div>
        <Button color="primary" onPress={() => setLoginModal(true)}>
          {getValue("app_v2_login")}
        </Button>
        {loginModal && <Login isOpen={loginModal} setIsOpen={setLoginModal} />}
      </div>
    )
  }

  if (!isVipBrand)
    return (
      <div className="flex flex-col gap-2 items-center justify-center h-full w-full  relative overflow-y-scroll pb-[50%]">
        <div className="">{getValue("vip.not.available")}</div>
        <Button color="primary" onPress={() => window.location.reload()}>
          {getValue("vip.reload")}
        </Button>
      </div>
    )
  //console.log("userData is ", userData)
  return (
    <div
      className={`flex flex-col gap-2 items-center h-full w-full  relative overflow-y-scroll pb-[50%] ${appParams?.styles?.fonts?.capitalize ? "font-extrabold uppercase" : ""
        }`}
    >
      {pointRedemption && (
        <UsePointsModal isOpen={isOpen} setIsOpen={setIsOpen} />
      )}
      <div className="w-full flex flex-row items-center justify-center gap-1 px-2 py-2 relative">
        <div className="w-full flex flex-col  px-2">
          {userData?.email == null && (
            <>
              {getValue("vip.reload.needed")}
              <Button color="primary" onPress={() => window.location.reload()}>
                {getValue("vip.reload")}
              </Button>
            </>
          )}
          <div className="text-4xl font-bold text-center">
            {languageCode === "hu"
              ? `${userData?.lastName || ""} ${userData?.firstName || ""}`
              : `${userData?.firstName || ""} ${userData?.lastName || ""}`}
          </div>
          <div className="text-center mt-2">
            <div className="font-normal">
              {getValue("app_v2_vip_point_balance")}:
            </div>
            <div className="text-4xl">{userData?.points || 0}</div>
          </div>
          {userData?.cardRules?.nextLevel?.purchasePoints > 0 && (
            <div className="flex gap-1 justify-center mt-2">
              <div className="text-sm">
                {getValue("app_v2_vip_next_level")}:
              </div>
              <div className="text-sm">
                {+(userData?.cardRules?.nextLevel?.purchasePoints || 0) -
                  +(userData?.purchasePoints || 0)}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="flip-card-div shrink-0 w-full">
        <ReactCardFlip isFlipped={isFlipped} flipDirection="vertical">
          <div className="w-[400px] max-w-full m-auto cursor-pointer">
            <div className="aspect-ratio">
              <div
                onClick={() => setIsFlipped(!isFlipped)}
                className="vip-card-root animation-shine delay1 !bg-[--button-bg-color] h-full w-full"
                style={
                  appParams?.vip?.vipCardBgType === "2"
                    ? {
                      backgroundImage: `url(${defaultVipCardBgImgUrl})`,
                    }
                    : {}
                }
              >
                <div className="vip-reload">
                  {/* <LoadSvg name={'setHistory'} /> */}
                </div>
                {/* <div className="vip-header">
              <div className="vip-icon"></div>
              <div className="vip-title">
                TIER {userData?.cardTypeID}
              </div>
            </div> */}
                {/* <div className="font-normal normal-case font-extraLarge h-[2em] py-1 bg-black/40 flex items-center justify-center">
              <span className="hidden-content appear">
                {languageCode === "hu"
                  ? `${userData?.lastName} ${userData?.firstName}`
                  : `${userData?.firstName} ${userData?.lastName}`}
              </span>
            </div> */}
                {/* <div className="vip-points font-small"> */}
                <>
                  {/* {appParams?.styles?.vip?.showOnCard === "points" && (
                      <div className="hidden-content appear">
                        <span className="vip-points-label text-[var(--button-text-color)]">
                          {getValue("app_v2_vip_pointsLabel")}:
                        </span>
                        <span className="vip-points-amount text-[var(--button-text-color)]">
                          {userData?.points}
                        </span>
                        <span className="vip-points-currency text-[var(--button-text-color)]">
                          {getValue("app_v2_vip_pointsCurrency")}
                        </span>
                      </div>
                    )} */}
                  {/* {appParams?.styles?.vip?.showOnCard === "money" && (
                      <div className="hidden-content appear">
                        <span className="vip-points-label text-[var(--button-bg-color)]">
                          {getValue("app_v2_vip_pointsLabel")}:
                        </span>
                        <span className="vip-points-amount ml-2 text-[var(--button-bg-color)]">
                          <NumericFormat
                            value={+userData?.money}
                            decimalSeparator=","
                            suffix=" Ft"
                            thousandSeparator="."
                            displayType="text"
                          />
                        </span>
                      </div>
                    )} */}
                </>
                {/* </div> */}
              </div>
            </div>
          </div>
          <div className="w-[400px] max-w-full m-auto cursor-pointer">
            <div className="aspect-ratio">
              <div
                onClick={() => setIsFlipped(!isFlipped)}
                className="vip-card-root animation-shine delay1 !bg-[--button-bg-color]"
                style={{
                  backgroundColor: appParams?.styles?.qrCode?.bgColor || "#FFFFFF",
                  color: appParams?.styles?.qrCode?.fgColor || "#000000",
                }}
              >
                <div
                  className={`qr-root ${userData?.vipID == null ? "blur-on" : "blur-off"
                    }`}
                >
                  <QRCodeSVG
                    value={userData?.vipID + ""}
                    includeMargin={true}
                    renderAs="svg"
                    size={160}
                    level="H"
                    bgColor={appParams?.styles?.qrCode?.bgColor || "#FFFFFF"}
                    fgColor={appParams?.styles?.qrCode?.fgColor || "#000000"}
                  />
                  <div className="short-id font-large hidden-content appear">
                    {userData?.shortID}
                  </div>
                  {/* {vipID != null && <div className='short-id font-large hidden-content appear'>{vipID}</div>} */}
                </div>
              </div>
            </div>
          </div>
        </ReactCardFlip>
      </div>
      <div className="vip-desc text-xs normal-case font-normal">
        {getValue("app_v2_vip_flip_desc")}
      </div>
      <div className="mt-2 flex items-center gap-1">
        <span>{getValue("app_v2_vip_redemption_part1")}</span>
        <span>{userData?.pointsPercent}</span>
        <span>{getValue("app_v2_vip_redemption_part2")}</span>
      </div>
      <div className="mt-2 text-center max-w-[80%]">
        {getValue("app_v2_vip_desc2")}
      </div>
      <div className="mt-2 font-small font-normal flex items-center gap-1">
        <span>{getValue("app_v2_vip_card_discount")}:</span>
        <span>{userData?.discount || 0}%</span>
      </div>
      {pointRedemption && (
        // <div>
        //   <Button color="primary" onClick={() => setIsOpen(true)}>
        //     {getValue("app_v2_vip_usePoints")}
        //   </Button>
        // </div>
        <div className="w-full px-4 flex items-center justify-center flex-col">
          <Slider
            label={
              <>
                <span>{getValue("app_v2_vip_points_slider")}</span>
                <span className="text-[10px] font-light normal-case ml-2">
                  {getValue("app_v2_vip_points_slider_2")}
                </span>
              </>
            }
            step={100}
            maxValue={userVipPoints || 0}
            minValue={0}
            defaultValue={0}
            className="max-w-md"
            value={sliderValue}
            onChange={(e) => {
              setSliderValue(isNaN(e) ? 0 : e)
            }}
          />
          <div className="text-center mt-2">
            <div className="text-xs mb-2">
              {getValue("app_v2_vip_points_desc")}
            </div>
            <Button
              color="primary"
              disabled={reserveLoading}
              onClick={() => handleSetPoints()}
              className="min-w-[140px]"
            >
              {!reserveLoading &&
                `${getValue("app_v2_vip_points_btn")} - ${sliderValue}`}
              {reserveLoading && (
                <CircularProgress
                  color="primary"
                  size="sm"
                  aria-label="aria label"
                />
              )}
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default VIP
